<!-- ToDo: Jump to tree (select article), define a global style for the input box -->
<template>
  <b-nav-text class="simple-search" v-on-click-outside="handleClickOutside" v-on:keyup.prevent="startSearchEvent">
    <div class="simple-search-container" :class="{ extended: isSearchExtended }" @click="$refs.simpleSearchInput.focus()">
      <span class="simple-search-front-icon">
        <Icon icon="Magnify" data-cy="search-article-icon" />
      </span>
      <div class="navbar-search-input-wrapper">
        <input
          type="text"
          class="navbar-search-input"
          @keydown="searchInputKeydownHandler"
          @blur="searchInputInFocus = false"
          @focus="searchInputInFocus = true"
          autocomplete="off"
          v-model="searchTerm"
          :placeholder="this.$t('SearchArticle')"
          @keyup.prevent.down="chooseEntry(1)"
          @keyup.prevent.up="chooseEntry(-1)"
          @keypress.prevent.enter="chooseEntry(0)"
          ref="simpleSearchInput"
          data-cy="search-article-txt" />
      </div>
      <div class="adv-search-button-wrapper" :class="{ show: isSearchExtended }" v-if="config.feature.advancedSearchEnabled">
        <b-btn variant="link" class="simple-search-adv-search-button mr-2" data-cy="advance-search-btn" @click="isAdvSearchModalOpen = true">
          {{ $t("advancedSearch") }}
        </b-btn>
      </div>
      <span class="simple-search-clear-button-wrapper" :class="{ show: searchTerm }" v-show="searchTerm">
        <b-btn class="btn-icon mono" @click="clearSearch" data-cy="clear-search-article-btn">
          <Icon icon="Close" />
        </b-btn>
      </span>
      <AdvancedSearchModal v-model="isAdvSearchModalOpen" />
    </div>
    <div class="simple-search-result-container" v-if="showDetails">
      <SimpleSearchResults
        :articleDisplayResults="articleDisplayResults"
        @selected="handleSelection"
        @navigate-next="loadNextPage"
        @navigate-previous="loadPreviousPage"
        :selectSearchRow="resultSelection"
        :searchPhrases="searchPhrases"
        :actPage="actPage"
        :lastPage="lastPage"
        :language="language"
        :loading="searchInUse"
        :highlightArticleId="tobeHighlightedArticleId" />
    </div>
  </b-nav-text>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import searchapi from "@/services/search.js";
import SimpleSearchResults from "@common/components/SimpleSearchResults.vue";
import AdvancedSearchModal from "@AdvancedSearch/views/AdvancedSearchModal.vue";
import Icon from "@common/components/Icon.vue";

export default {
  components: {
    SimpleSearchResults, //Sub component for display results from search
    AdvancedSearchModal,
    Icon
  },
  data: () => ({
    showDetails: false, //Focus on search input
    searchTerm: "", //Given search phrase
    previousSearchTerm: "", //Prevent duplical searches
    articleDisplayResults: [], //Search results display (table data)
    position: 0, //Position in search results, in/decrease pagewise (see pageSize)
    resultSelection: 0, //Actual selection
    pageSize: 5, //Size of the result page. TODO: Read value from config
    lastPage: false, //Result is last page, set from response from the server
    catalogId: "3dffa603-a753-49df-bac7-aa1b00cc468d", //CatalogId for loading articles. ToDo: get catalog id from system instead const!
    searchInUse: false, //Prevent parallel calls if the server slow and the user is fast typing ;-)
    jumpInUse: false, //Prevent for parallel jumps without a jump (position change without a jump)
    searchPhrases: "",
    actPage: 0,
    searchInputInFocus: false,
    tobeHighlightedArticleId: null,
    isAdvSearchModalOpen: false
  }),
  methods: {
    startSearchEvent: async function () {
      //clean display results
      this.position = 0;
      this.resultSelection = -1;
      this.showDetails = this.searchTerm.length > 0;

      try {
        await this.runSimpleSearch(this.searchTerm);
      } catch (e) {
        if (!this.searchInUse) console.error("searchException", e);
      }
    },
    searchInputKeydownHandler() {
      this.showDetails = this.searchTerm?.length > 0;
    },
    runSimpleSearch: async function (searchTerm) {
      const vm = this;

      //Handle parallel requests
      if (vm.searchInUse) {
        return;
      }

      //Search term is empty
      if (searchTerm.length == 0) {
        vm.articleDisplayResults = [];
        vm.searchPhrases = "";
        vm.previousSearchTerm = "";
        return;
      }

      //search term isn't changed, no new search
      if (searchTerm === vm.previousSearchTerm) return;

      vm.previousSearchTerm = searchTerm;

      //Mark for parallel requests
      vm.searchInUse = true;
      //Get act search page
      vm.actPage = Math.floor(vm.position / vm.pageSize);

      //Check bounds of resultSelection. An event mess can trigger that resultSelection is outside boundary
      if (this.position < 0) {
        console.error("resultSelection outside the boundary:", this.resultSelection);
        this.position = 0;
      }

      //Get results from server
      try {
        const resp = await searchapi.simpleSearch(vm.language, vm.language, searchTerm, vm.pageSize, vm.position);
        vm.searchPhrases = resp.searchPhrases;
        vm.lastPage = resp.lastPage;
        vm.articleDisplayResults = [];
        //Simplify result for Display, format the text for present the search results
        vm.articleDisplayResults = resp.articles.map((article, i) => ({
          index: i,
          articleNo: article.number,
          articleId: article.id,
          Name: article.name,
          Description: article.description
        }));

        vm.searchInUse = false;
        vm.showDetails = true;
        if (vm.previousSearchTerm !== this.searchTerm) await this.runSimpleSearch(this.searchTerm);
      } catch (error) {
        console.error(error);
      }
    },
    searchRequest(url) {
      return this.$http
        .get(url)
        .success(function (returnedData) {
          return returnedData;
        })
        .error(function (returnedData) {
          return returnedData;
        });
    },
    jumpTo: async function (direction) {
      try {
        //handleSelection could be take a while, during this time should be the resultSelection not changed!
        if (this.jumpInUse) return;

        this.jumpInUse = true;
        //Move selection with effect in sub component
        this.resultSelection += direction;

        //Reactivate search results
        this.showDetails = true;

        //load articles from new selection
        if (this.resultSelection < this.pageSize && this.resultSelection >= 0) {
          await this.handlePageChange(this.articleDisplayResults[this.resultSelection]);
          this.jumpInUse = false;
          return;
        }

        const vm = this;
        if (!vm.searchInUse) {
          //The end of the table is reached
          if (vm.resultSelection >= vm.pageSize) {
            vm.position += vm.pageSize;
            vm.previousSearchTerm = "";
            await vm.runSimpleSearch(vm.searchTerm);
            //Select first entry
            //TODO: This "Troubleshooting" (with setTimeout) is a Symtomatic Troubleshooting! At this point there is probably a timing problem.
            //"vm.articleDisplayResults" is not defined directly after ".then". There should be another solution than "setTimeout".
            vm.resultSelection = 0;
            await vm.handlePageChange(vm.articleDisplayResults[vm.resultSelection]);
            vm.jumpInUse = false;
          }

          //Start of the table is reached
          if (vm.resultSelection < 0) {
            vm.position -= vm.pageSize;
            vm.previousSearchTerm = "";
            await vm.runSimpleSearch(vm.searchTerm);
            //set selection to last entry
            //TODO: This "Troubleshooting" (with setTimeout) is a symtomatic Troubleshooting! At this point there is probably a timing problem.
            //"vm.articleDisplayResults" is not defined directly after ".then". There should be another solution than "setTimeout".
            vm.resultSelection = vm.pageSize - 1;
            await vm.handlePageChange(vm.articleDisplayResults[vm.resultSelection]);
            vm.jumpInUse = false;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    loadNextPage: async function () {
      try {
        if (this.position == 0) {
          await this.jumpTo(1 + this.pageSize);
        } else {
          await this.jumpTo(this.position + this.pageSize);
        }
      } catch (error) {
        console.error(error);
      }
    },
    loadPreviousPage: async function () {
      try {
        let pageDirection = this.position - this.pageSize;
        if (pageDirection <= 0) {
          pageDirection = this.pageSize;
        }
        await this.jumpTo(-pageDirection);
      } catch (error) {
        console.error(error);
      }
    },
    handleSelection: async function (selection) {
      //Event from sub component, selection is changed.
      try {
        await this.$router.push({
          name: "article-editor",
          params: { id: selection.articleId }
        });
        this.resultSelection = selection.index;
      } catch (error) {
        console.error("navigation error", error);
      }
    },
    handlePageChange: async function (selection) {
      this.resultSelection = selection.index;
    },
    handleClickOutside(event) {
      if (!event.target.closest("#nav-search-results")) {
        this.showDetails = false;
        this.tobeHighlightedArticleId = null;
      }
    },
    clearSearch() {
      this.showDetails = false;
      this.searchTerm = null;
      this.tobeHighlightedArticleId = null;
    },
    chooseEntry(direction) {
      if (this.showDetails && this.articleDisplayResults.length > 0) {
        let indexOfChosenRow = _.findIndex(this.articleDisplayResults, {
          articleId: this.tobeHighlightedArticleId
        });

        if (indexOfChosenRow != -1) {
          indexOfChosenRow += direction;
        } else {
          indexOfChosenRow = 0;
        }
        if (!this.articleDisplayResults[indexOfChosenRow]) {
          return;
        }
        if (direction == 0) {
          this.handleSelection(this.articleDisplayResults[indexOfChosenRow]);
        }
        this.tobeHighlightedArticleId = this.articleDisplayResults[indexOfChosenRow].articleId;
      }
    }
  },
  computed: {
    ...mapState("metadata", ["contentLanguages", "config"]),
    language() {
      return this.contentLanguages.enabled.length ? this.contentLanguages.enabled[0].languageCode : "";
    },
    isSearchExtended() {
      return this.searchInputInFocus || this.searchTerm;
    }
  },
  watch: {
    searchInputInFocus: function (nv) {
      if (nv && this.searchTerm) this.showDetails = true;
    }
  }
};
</script>
